var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_74)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3593 41.7947H31.3333V35.1793H14.3593V41.7947ZM37.6927 41.7947H44.3073V22.2053H37.6927V41.7947ZM14.3593 28.8207H31.3333V22.2053H14.3593V28.8207ZM8.82067 52C7.47356 52 6.33333 51.5333 5.4 50.6C4.46667 49.6667 4 48.5264 4 47.1793V16.8207C4 15.4736 4.46667 14.3333 5.4 13.4C6.33333 12.4667 7.47356 12 8.82067 12H49.846C51.1931 12 52.3333 12.4667 53.2667 13.4C54.2 14.3333 54.6667 15.4736 54.6667 16.8207V47.1793C54.6667 48.5264 54.2 49.6667 53.2667 50.6C52.3333 51.5333 51.1931 52 49.846 52H8.82067ZM8.82067 48H49.846C50.0513 48 50.2393 47.9144 50.41 47.7433C50.5811 47.5727 50.6667 47.3847 50.6667 47.1793V16.8207C50.6667 16.6153 50.5811 16.4273 50.41 16.2567C50.2393 16.0856 50.0513 16 49.846 16H8.82067C8.61533 16 8.42733 16.0856 8.25667 16.2567C8.08556 16.4273 8 16.6153 8 16.8207V47.1793C8 47.3847 8.08556 47.5727 8.25667 47.7433C8.42733 47.9144 8.61533 48 8.82067 48Z",
    fill: "#FF4444"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3593 41.7947H42.3333V35.1793H25.3593V41.7947ZM48.6927 41.7947H55.3073V22.2053H48.6927V41.7947ZM25.3593 28.8207H42.3333V22.2053H25.3593V28.8207ZM19.8207 52C18.4736 52 17.3333 51.5333 16.4 50.6C15.4667 49.6667 15 48.5264 15 47.1793V16.8207C15 15.4736 15.4667 14.3333 16.4 13.4C17.3333 12.4667 18.4736 12 19.8207 12H60.846C62.1931 12 63.3333 12.4667 64.2667 13.4C65.2 14.3333 65.6667 15.4736 65.6667 16.8207V47.1793C65.6667 48.5264 65.2 49.6667 64.2667 50.6C63.3333 51.5333 62.1931 52 60.846 52H19.8207ZM19.8207 48H60.846C61.0513 48 61.2393 47.9144 61.41 47.7433C61.5811 47.5727 61.6667 47.3847 61.6667 47.1793V16.8207C61.6667 16.6153 61.5811 16.4273 61.41 16.2567C61.2393 16.0856 61.0513 16 60.846 16H19.8207C19.6153 16 19.4273 16.0856 19.2567 16.2567C19.0856 16.4273 19 16.6153 19 16.8207V47.1793C19 47.3847 19.0856 47.5727 19.2567 47.7433C19.4273 47.9144 19.6153 48 19.8207 48Z",
    fill: "#FF4444"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.6842 8V15.2558L35 20.8372L45 24.7442L37.7072 29.2093L38.6842 34.2326L45 37.5814L38.6842 44.2791L40.2632 48.186L38.6842 50.9767V56",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 11V17.5L28 22.5L37.5 26L30.5718 30L31.5 34.5L37.5 37.5L31.5 43.5L33 47L31.5 49.5V54",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6842 8V15.2558L32 20.8372L42 24.7442L34.7072 29.2093L35.6842 34.2326L42 37.5814L35.6842 44.2791L37.2632 48.186L35.6842 50.9767V56",
    stroke: "#FF4444",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 40,
    fill: "white",
    transform: "translate(4 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 40,
    fill: "white",
    transform: "translate(36 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenExpired);
export default __webpack_public_path__ + "static/media/token-expired.fa2f279a478f1070d331fd732f35537d.svg";
export { ForwardRef as ReactComponent };